module.exports = __webpack_public_path__ + "static/img/10.4df5161f.png";